import * as React from 'react';
import { observer } from 'mobx-react';

import { HomeView } from './home.view';
import { resolve } from 'inversify-react';
import { IdentityService } from 'src/core/services/identity.service';

@observer
export class HomeController extends React.Component<{}, {}> {

	@resolve
	identityService: IdentityService;

	render(): React.ReactNode {
		return (
			<HomeView userId={this.identityService.userId} />
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/home/home.controller.tsx